module.exports = __webpack_public_path__ + "static/media/inVisibleShare.e9f2bc75.svg";